export enum PermissionType {
    ReadPermission = "read",
    WritePermission = "write",
    UpdatePermission = "update",
    DeletePermission = "delete",
    ImportPermission = "import",
    ExportPermission = "export",
}